{
  "PasswordChange_Title": "Change Password",
  "PasswordReset_Title": "Password Reset",
  "PasswordChange_SubTitle": "Please enter your current password, your new desired password (minimum of {} characters required), as well as your new password again to confirm its new value.",
  "PasswordReset_SubTitle": "Please enter your new desired password (minimum of {} characters required), as well as your new password again to confirm its new value.",
  "PasswordReset_Success": "You have successfully updated the password against your user account.\n\nPlease click the **Continue** button which will return you back to the main Welcome page, where you can also then click the \"Sign In\" link in order to access your account.",
  "PasswordChange_Fields_OldPassword": "Current Password",
  "PasswordChange_Fields_NewPassword": "New Password",
  "PasswordChange_Fields_ConfirmPassword": "Confirm New Password",
  "PasswordChange_Validations_PasswordsMustMatch": "Passwords do not match",
  "PasswordChange_Validations_CurrentRequired": "Current password required",
  "PasswordChange_Validations_NewRequired": "New password required",
  "PasswordChange_Validations_ConfirmRequired": "Confirm password required",
  "PasswordChange_Actions_ChangePassword": "Change Password",
  "PasswordChange_Actions_Cancel": "Cancel",
  "PasswordChange_Actions_Continue": "Continue",
  "NAME": "PasswordChangeLanguage"
}